import { branding } from '@/config/branding';

/**
 * The school logo mark on a rounded white tile. Used in the sider header and
 * on the login screen. Sizing/shape comes from the `.brand-mark` class; pass
 * `className` (e.g. `login-brand-mark`) to override.
 */
export function BrandMark({ className = '' }: { className?: string }) {
  return (
    <div className={`brand-mark ${className}`.trim()}>
      <img src="/logo-mark.png" alt={`${branding.shortName} logo`} draggable={false} />
    </div>
  );
}
